<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-sidebar ref="productSidebar" />

    <div class="flex justify-between">
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      <div class="flex justify-end">
        <!-- <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3">Add new</vs-button> -->
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredSalesProducts" @selected="onClicked">
        <template slot="header">
          <div class="flex mb-2">
            <vs-select v-model="filters.salesGroup" autocomplete class="w-3/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.salesGroup" />
            </vs-select>
          </div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th>Sales group</vs-th>
          <vs-th sort-key="color">Color</vs-th>
          <vs-th sort-key="isReadyForSale">Sellable?</vs-th>
          <!-- <vs-th sort-key="price">Sales price</vs-th> -->
          <vs-th sort-key="createdAt">Created at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="ProductIcon" />
                    <div class="ml-4">
                      <div v-if="tr.salesProduct.name">
                        {{ tr.salesProduct.name }}
                      </div>
                      <div v-else>
                        <vs-chip> No name </vs-chip>
                      </div>
                      <small>{{ tr.salesProduct.shortId }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip class="z-10 w-32 flex justify-start" :color="matchingSalesGroup(tr.salesProduct).color">
                  {{ matchingSalesGroup(tr.salesProduct).name }}
                </vs-chip>
              </vs-td>
              <vs-td class="pr-0">
                <vs-chip :color="tr.salesProduct.color" class="w-12"></vs-chip>
              </vs-td>
              <!-- <vs-td> {{ tr.salesProductType == "Priceable" ? "-" : tr.prices[0].price }} </vs-td> -->
              <!-- <vs-td> </vs-td> -->
              <vs-td>
                <vs-chip :color="tr.isReadyForSale | yesnocolor" class="w-12">
                  {{ tr.isReadyForSale | yesno }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <div v-if="tr.salesProduct.createdAction.timestamp" class="flex">
                  <feather-icon class="mr-1" :icon="'CalendarIcon'" svgClasses="text-grey w-5 h-5" />
                  {{ tr.salesProduct.createdAction.timestamp | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductSidebar from "./AssignedSalesProductSidebar.vue";

export default {
  components: {
    HandleProductSidebar
  },
  props: {
    venueId: {
      type: String,
      default: undefined,
      required: false
    }
  },
  data() {
    return {
      ProductIcon,
      isLoading: true,

      filters: {
        salesGroup: null
      }
    };
  },
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        let venueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          venueId = this.$store.getters["venues/activeVenueId"];
        }

        await this.$store.dispatch("pos/assignedSalesProducts/getAssignedSalesProductsByVenue", venueId);
        await Promise.all([this.$store.dispatch("pos/countrySettings/getCountrySettings")]);
        this.isLoading = false;
      },
      immediate: true
    }
  },
  methods: {
    onClicked(item) {
      this.$refs.productSidebar.show(item.id);
    },
    async onClickCreateNew() {
      this.$refs.productSidebar.showEmptyProduct();
    },
    matchingSalesGroup(salesProduct) {
      return this.salesGroups.find(e => e.salesProductGroupId.id === salesProduct.salesProductGroupId);
    },
    matchingSalesSubGroup(salesProduct) {
      const match = this.salesSubGroups.find(e => e.salesProductSubGroupId.id === salesProduct.salesProductSubGroupId);
      return match && salesProduct.salesProductSubGroupId != "None" ? match : { name: "None", color: "grey" };
    }
  },
  computed: {
    ...mapGetters({
      assignedSalesProducts: "pos/assignedSalesProducts/assignedSalesProducts",

      countries: "pos/countries/countries",
      salesGroups: "pos/countrySettings/salesProductGroups"
    }),

    selectableFilters() {
      return {
        salesGroup: [
          { text: "Filter by sales group", value: null },
          ...this.salesGroups.map(e => ({
            text: e.name,
            value: e.salesProductGroupId.id
          }))
        ]
      };
    },

    filteredSalesProducts() {
      return this.assignedSalesProducts
        .filter(e => {
          if (this.filters.salesGroup && e.salesProduct.salesProductGroupId != this.filters.salesGroup) {
            return false;
          }

          return true;
        })
        .slice()
        .sort((a, b) => (a.salesProduct.createdAction.timestamp < b.salesProduct.createdAction.timestamp ? 1 : -1));
    }
  },

  async created() {
    this.isLoading = true;
    await Promise.all([this.$store.dispatch("pos/countrySettings/getCountrySettings")]);
    this.isLoading = false;
  }
};
</script>